import React from 'react';
import NewField from '../common/NewField';
import { useAddFieldHook } from '../hooks/useAddFieldHook';

interface FieldNewProps {
  fieldLabels: string[];
  trainingSetId: string;
  width?: number;
  withAddButton?: boolean;
  cypressId?: string;
}

const FieldNew: React.FunctionComponent<FieldNewProps> = ({
  fieldLabels,
  trainingSetId,
  width,
  withAddButton,
  cypressId,
}) => {
  const { addField } = useAddFieldHook({ trainingSetId });

  const addFieldHandler = (label: string) => {
    addField({
      label,
      training_set: trainingSetId,
    });
  };

  return (
    <div style={{ margin: '.5em 0', display: 'flex', alignItems: 'center' }}>
      <NewField
        label="New Field"
        items={fieldLabels}
        add={addFieldHandler}
        width={width}
        withAddButton={withAddButton}
        cypressId={cypressId}
      />
    </div>
  );
};

export default FieldNew;
